import { useSelector } from 'react-redux'

// slices
import { loginState } from '../../modules/login/login.slice'

// styles
import styles from './navigation.module.css'

// constants
import {
    CHECK_TALENT_DOMAIN,
    DOMAIN_LIST,
    SUPER_ADMIN,
} from '../../constants/roles'

// routes
import { PRIVATE_ROUTES } from '../../routes'
import { FaSuitcase } from 'react-icons/fa6'
import { ImUsers } from 'react-icons/im'

function SuperAdminRoutesNavigation(selected) {
    // console.log(selected)
    const { status, userProfile } = useSelector(loginState)

    return status !== 'loading' &&
        userProfile &&
        userProfile?.role?.roleName !== undefined &&
        DOMAIN_LIST.includes(userProfile?.currentWorkSpace?.domain) &&
        (userProfile?.role?.roleName === SUPER_ADMIN ||
            (userProfile?.role?.roleName !== SUPER_ADMIN &&
            userProfile?.appPermission?.length > 0
                ? userProfile?.appPermission.some((app) =>
                      CHECK_TALENT_DOMAIN.includes(app.domain)
                  )
                : false))
        ? [
              // {
              //     key: 'workspace',
              //     label: 'Workspace',
              //     route: PRIVATE_ROUTES.workSpace,
              //     icon: (
              //         <WorkSpaceIcon
              //             className={styles.icon + ' in-btn'}
              //             color={selected === 'workspace'}
              //         />
              //     ),
              // },
              {
                  key: 'jobs',
                  route: PRIVATE_ROUTES.jobs,
                  label: 'Jobs',
                  icon: <FaSuitcase className={styles.icon + ' in-btn'} />,
              },
              {
                  key: 'candidates',
                  route: PRIVATE_ROUTES.candidate.root,
                  label: 'Candidate',
                  icon: <ImUsers className={styles.icon + ' in-btn'} />,
              },

              {
                  key: 'talent',
                  route: PRIVATE_ROUTES.talent,
                  label: 'Resource',
                  icon: <ImUsers className={styles.icon + ' in-btn'} />,
              },

              // {
              //     key: 'workload',
              //     route: PRIVATE_ROUTES.workload,
              //     label: 'Allocation',
              //     icon: <Workload className={styles.icon + ' in-btn'} />,
              // },
              // {
              //     key: 'inquiries',
              //     route: PRIVATE_ROUTES.inquiries,
              //     label: 'Inquiries',
              //     icon: <InquiriesIcon className={styles.icon + ' in-btn'} />,
              // },
              // {
              //     key: 'recruit',
              //     route: PRIVATE_ROUTES.recruit,
              //     label: 'Recruit',
              //     icon: <RecruitIcon className={styles.icon + ' in-btn'} />,
              // },
              //   {
              //       key: 'chat',
              //       route: PRIVATE_ROUTES.chat,
              //       label: 'Chat',
              //       icon: <ChatIcon className={styles.icon + ' in-btn'} />,
              //   },
          ]
        : []
}

export default SuperAdminRoutesNavigation
